<template>
  <div id="app">
    <navbar-component></navbar-component>
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>

const NavbarComponent = () => import('@/components/Shared/Navbar/navbar.components.vue')
import { setToken, refresh, getInfo  } from "@/api/auth.service.js";

export default {
  name: 'app',
  components:{
    NavbarComponent
  },
  created() {
    if (localStorage.token) {
      setToken(localStorage.token);
      this.$store.dispatch('refresh');
      this.$store.dispatch('setLanguages')
      refresh(localStorage.token).then(response => {
        console.log("test lis ");
        getInfo(response).then((user) => {
          this.$store.dispatch('setCurrentUser', user)
          this.$store.dispatch("setAllInfoBotsByUser");
        })
      });

    }
  }

}
</script>

<style>
body {
  margin: 0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue